import { isMobilePhone, isStrongPassword } from "validator"

export const isValidName = (name: string): boolean => {
  
  const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ]+([' -][a-zA-ZÀ-ÖØ-öø-ÿ]+)*$/
  return regex.test(name.trim())
}

export const isValidPassword = (password: string): boolean => {
  return isStrongPassword(password, {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
  })
}

export const isValidPhoneNumber = (phone: string): boolean => {
  const normalisedPhone = phone.trim().replace(/\s+/g, '')
  return isMobilePhone(normalisedPhone, "any")
}

export const isValidAddress = (address: string): boolean => {
  const regex = /^[a-zA-Z0-9\s,.'-]+$/
  return regex.test(address.trim())
}

export const isValidCityOrCounty = (city: string): boolean => {
  const regex = /^[a-zA-Z\s'-]+$/
  return regex.test(city.trim()) && city.trim().length > 0
}

export const isValidPostcode = (postcode: string): boolean => {
  const regex = /^[A-Za-z0-9\s-]+$/
  return regex.test(postcode.trim())
}

export const isValidCountry = (country: string): boolean => {
  const regex = /^[a-zA-Z\s]+$/
  return regex.test(country.trim())
}

export const isValidDob = (dob: string): boolean => {
  // Check for valid date format
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/
  if (!dateRegex.test(dob)) return false

  // Check if the date is not in the future
  const dobDate = new Date(dob)
  const today = new Date()
  if (dobDate > today) return false

  // Calculate age
  // const age = today.getFullYear() - dobDate.getFullYear()
  // const isBirthdayPassedThisYear =
  //   today.getMonth() > dobDate.getMonth() ||
  //   (today.getMonth() === dobDate.getMonth() && today.getDate() >= dobDate.getDate())

  // const actualAge = isBirthdayPassedThisYear ? age : age - 1

  // Check age restrictions (e.g., minimum 18 years, maximum 120 years)
  // if (actualAge < 18 || actualAge > 120) return false

  return true
}

export const isValidAccountType = (accountType: string): boolean => {
  const accountTypes = ["gymnast", "assistant", "coach", "director"]
  return accountTypes.includes(accountType)
}

export const isValidMembershipSpaces = (membershipSpaces: number): boolean => {
  return membershipSpaces >= 0
}
